const VideoElement = globalThis.HTMLElement ?? class {};

class RilavereConceptVideo extends VideoElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.toggle = this.querySelector('[data-video-toggle]');
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.inView = false;
    this.userPaused = false;
    this.userOverride = false;
    this.updateToggle = () => {
      if (!this.toggle) return;
      this.toggle.textContent = this.video.paused ? 'Play film' : 'Pause film';
    };
    this.sync = () => {
      if (!this.inView || this.userPaused || (this.motion.matches && !this.userOverride)) {
        this.video.pause();
      } else {
        this.video.play().catch(() => {});
      }
      this.updateToggle();
    };
    this.toggle?.addEventListener('click', () => {
      if (this.video.paused) {
        this.userPaused = false;
        this.userOverride = true;
      } else {
        this.userPaused = true;
      }
      this.sync();
    });
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.inView = entry.isIntersecting;
        if (!this.inView) this.userOverride = false;
        this.sync();
      },
      { threshold: 0.35 },
    );
    this.observer.observe(this);
    this.motion.addEventListener('change', this.sync);
    this.video.addEventListener('play', this.updateToggle);
    this.video.addEventListener('pause', this.updateToggle);
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.motion?.removeEventListener('change', this.sync);
  }
}

if (globalThis.customElements && !globalThis.customElements.get('rilavere-concept-video')) {
  globalThis.customElements.define('rilavere-concept-video', RilavereConceptVideo);
}
